// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(status) {
  switch (status) {
    case "deleted" :
        return /* Deleted */3;
    case "pending" :
        return /* Pending */0;
    case "rejected" :
        return /* Rejected */2;
    case "scheduled" :
        return /* Scheduled */1;
    default:
      return ErrorUtils$Catalyst.raiseError("PricingCampaign.re", "Invalid Campaign Status", status);
  }
}

function to_string(status) {
  switch (status) {
    case /* Pending */0 :
        return "pending";
    case /* Scheduled */1 :
        return "scheduled";
    case /* Rejected */2 :
        return "rejected";
    case /* Deleted */3 :
        return "deleted";
    
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

export {
  fromString ,
  to_string ,
  t_decode ,
  
}
/* No side effect */
